import PortfolioPage from './PortfolioPage'

export default PortfolioPage
